<template>
  <b-form ref="form__redeem-code" disable-event-track @submit.prevent="redeem">
    <b-modal
      id="RedeemCodeModal"
      ref="modal__redeem-code"
      v-model="$show"
      class="modal__redeem-code"
      size="md"
      centered
      hide-header
      header-text-variant="light"
      no-close-on-backdrop
      no-close-on-esc
      static
      scrollable
      :hide-footer="redeemSuccess"
      @hide="onHide()"
    >
      <template #default="{ hide }">
        <b-container>
          <b-row v-if="redeemSuccess" ref="content__text-success" class="content__text-success">
            <b-col cols="12">
              <button
                ref="button__close-modal"
                type="button"
                aria-label="Close"
                class="close button__close-modal"
                @click="hide()"
              >
                ×
              </button>
            </b-col>
            <b-col class="px-3 py-4">
              <b-col cols="12" class="text-center">
                <!-- <svg
                  class="mb-3"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="36"
                  height="36"
                  fill="rgba(27,201,67,1)"
                >
                  <path
                    d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM17.4571 9.45711L11 15.9142L6.79289 11.7071L8.20711 10.2929L11 13.0858L16.0429 8.04289L17.4571 9.45711Z"
                  ></path>
                </svg> -->
                <h2 ref="text__successful" class="font-weight-bold m-0">Successful!</h2>
              </b-col>
              <RedeemResultList v-if="hasStackData" :stack="stack" />
              <div v-else>
                <b-col cols="12" class="text-center my-3">
                  <div ref="text__success-modal">{{ successTextModal }}</div>
                </b-col>
              </div>
              <b-col cols="12" class="text-center pt-3">
                <b-button
                  ref="button__go-to-dashboard"
                  variant="success"
                  class="button__go-to-dashboard"
                  @click="hadleSuccessAction()"
                >
                  {{ successTextButton }}
                </b-button>
              </b-col>
              <b-col v-if="closeButtonText" cols="12" class="d-flex justify-content-center mt-2">
                <b-button
                  ref="button__close"
                  type="button"
                  variant="link"
                  aria-label="Close"
                  class="button__close w-100"
                  @click="handleCloseAction()"
                >
                  {{ closeButtonText }}
                </b-button>
              </b-col>
            </b-col>
          </b-row>

          <b-row v-else class="text-light content__text-redeem">
            <b-col cols="12" class="img__backgroud">
              <b-img-lazy fluid :src="require('@/assets/badge-key.png')" class="img__badge-key">
              </b-img-lazy>
            </b-col>
            <b-col cols="12">
              <button
                type="button"
                aria-label="Close"
                class="close text-light button__close-modal"
                @click="hide()"
              >
                ×
              </button>
            </b-col>
            <b-col cols="12" class="mt-3">
              <h2 class=""><b>Redeem Code</b></h2>
            </b-col>
            <b-col cols="12" class="mb-4">
              <div class="">Enter your redeem code in the field below.</div>
            </b-col>
            <!-- <b-col v-if="!$_isFeatureEnabled('purchase_buynow')" cols="12" sm="6" class="mb-4">
              <b-button
                class="btn btn-md btn-block button__get-code"
                style="border-radius: 42px"
                variant="warning"
                href="https://etskmutt.typeform.com/to/F6yEZlLX"
                target="_blank"
              >
                Get Access Code
              </b-button>
            </b-col> -->
            <b-col cols="12" class="mb-3">
              <b-form-input
                ref="input__redeem-code"
                v-model="code"
                placeholder="Enter your code"
                size="lg"
                class="input__redeem-code"
                name="input__redeem-code"
              ></b-form-input>

              <b-alert
                :show="errorMessage ? true : false"
                variant="danger"
                class="text-danger mt-2 mb-0 text__invalid-code"
                >{{ errorMessage }}</b-alert
              >
            </b-col>
          </b-row>
        </b-container>
      </template>
      <template #modal-footer>
        <b-container>
          <b-row>
            <b-col cols="12">
              <b-button
                ref="button__apply-code"
                type="submit"
                variant="success"
                class="w-100 button__apply-code"
                :disabled="redeeming"
              >
                <span v-if="redeeming">
                  <b-spinner small label="Redeeming ..." />
                </span>
                <span v-else>Apply Code</span>
              </b-button>
            </b-col>
          </b-row>
        </b-container>
      </template>
    </b-modal>
  </b-form>
</template>

<script>
import RedeemCode from '@/models/RedeemCode';
import Application from '@/models/Application';
import { notificationMixin } from '@/mixins/notificationMixin';
import { amplitudeMixin } from '@/mixins/amplitudeMixin';
import { optimizelyMixin } from '@/mixins/optimizelyMixin';
import RedeemResultList from './RedeemResultList.vue';

export default {
  components: {
    RedeemResultList
  },
  mixins: [notificationMixin, amplitudeMixin, optimizelyMixin],

  props: {
    mcId: {
      type: [String, Number],
      require: true,
      default: null
    },

    show: {
      type: Boolean,
      default: false
    },

    redeemType: {
      type: String,
      default: 'ENTRY'
    },

    successAlertMessage: {
      type: String,
      default: 'Access code is successfully verifed.'
    },

    failAlertMessage: {
      type: String,
      default: 'Access code fail to verify.'
    }
  },

  data() {
    return {
      code: '',
      errorMessage: null,
      redeeming: false,
      redeemSuccess: false,
      stack: {},
      successTextModal: 'Continue update your submission',
      successTextButton: 'Back to submission',
      closeButtonText: ''
    };
  },

  computed: {
    $show: {
      get() {
        return this.show;
      },

      set(v) {
        this.$emit('update:show', v);
      }
    },

    $code: {
      get() {
        // return this.code ? this.code.toUpperCase() : this.code;
        return this.code;
      },

      set(v) {
        this.$emit('update:code', v);
      }
    },
    isStackDetailPage() {
      return this.$route.name === 'stack-detail';
    },
    stackId() {
      return Number.parseInt(this.$route.params.stackId, 10);
    },
    hasStackData() {
      return this.stack && Object.keys(this.stack).length > 0;
    },
    userApplication() {
      if (!this.$currentUser?.id) {
        return [];
      }

      return Application.query()
        .where((app) => {
          return app.user?.id == this.$currentUser.id && app.learning_unit?.id == this.mcId;
        })
        .first();
    }
  },
  methods: {
    updateSuccessButtonState(newValue, oldValue) {
      const modeChanged = newValue?.mode !== oldValue?.mode;

      if (modeChanged) {
        this.successTextButton = 'Go to your dashboard';
        this.successTextModal = 'View your item in User Dashboard.';
        this.closeButtonText = 'Back to submission';
      } else {
        this.successTextButton = 'Back to your submission';
        this.successTextModal = 'Continue update your submission';
        this.closeButtonText = '';
      }
    },

    async redeem() {
      const code = this.$code;
      const { successAlertMessage, failAlertMessage } = this;
      const refFormRedeem = this.$refs['form__redeem-code'];

      if (!code.trim()) {
        this.errorMessage = 'Access code is required.';
        await this.$_amplitudeMixin_onSubmit(refFormRedeem, {
          Message: this.errorMessage
        });

        await this.$_amplitudeMixin_onCheck({
          IsAccessCodeInvalid: true,
          Message: this.errorMessage
        });

        return;
      }

      try {
        this.errorMessage = null;
        this.redeeming = true;

        // Capture old application state before redeeming
        const oldApplication = this.userApplication;
        let newApplication = null;

        if (this.isStackDetailPage) {
          const {
            response: { data }
          } = await RedeemCode.api().redeemStack({
            code,
            stack: this.stackId
          });

          this.stack = data;
        } else {
          await RedeemCode.api().redeem({
            code,
            learning_unit: this.mcId
          });

          const { response } = await Application.api().find({
            user: this.$currentUser.id,
            learning_unit: this.mcId
          });
          newApplication = response.data[0];
        }

        await this.$_amplitudeMixin_onSubmit(refFormRedeem, {
          Message: successAlertMessage
        });

        await this.$_amplitudeMixin_onCheck({
          IsAccessCodeInvalid: false
        });

        this.$toast.success(successAlertMessage);

        this.redeemSuccess = true;
        // this.$bvModal.hide('RedeemCodeModal');

        // Update button state comparing old and new application (mode can change)
        this.updateSuccessButtonState(newApplication, oldApplication);

        //this.$emit('redeem:success');
      } catch (error) {
        let errMessage = failAlertMessage;
        if (error && error.response && error.response.data) {
          errMessage = error.response.data.message;
        }

        await this.$_amplitudeMixin_onSubmit(refFormRedeem, {
          Message: errMessage
        });

        await this.$_amplitudeMixin_onCheck({
          IsAccessCodeInvalid: true,
          Message: errMessage
        });

        this.errorMessage = errMessage;
        this.$toast.error(failAlertMessage);
        this.$emit('redeem:fail');
      } finally {
        this.redeeming = false;
      }
    },

    onHide() {
      this.code = '';
      this.redeeming = false;
      this.errorMessage = null;

      if (this.redeemSuccess) {
        this.$emit('redeem-success:hide');

        if (this.redeemType === 'QUOTA') {
          window.location.reload();
        }
      } else {
        this.$emit('on:hide');
      }
    },

    hadleSuccessAction() {
      if (this.redeemType === 'QUOTA' && this.successTextButton == 'Back to your submission') {
        this.$emit('on:hide');
        this.$router.go(0); // reload
        return;
      } else {
        this.$router.push({
          name: 'user-dashboard'
        });
      }
    },
    handleCloseAction() {
      if (this.redeemType === 'QUOTA') {
        this.$router.go(0); // reload
      } else {
        this.onHide();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .modal-body {
  padding: 0;
  scrollbar-width: none; /* Hide scrollbar in Firefox */
  -ms-overflow-style: none; /* Hide scrollbar in Internet Explorer */
}

::v-deep .modal-dialog-scrollable .modal-body::-webkit-scrollbar {
  display: none; /* Hide scrollbar in Chrome, Safari, and Edge (WebKit-based) */
}

::v-deep .modal-footer {
  border-top: 1px;
}

.content__text-redeem {
  border-radius: 0.5rem 0.5rem 0rem 0rem !important;
  background-image: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
  padding: 1rem;
}

.content__text-success {
  padding: 1rem 0;
}

.img {
  &__backgroud {
    display: flex;
    justify-content: flex-end;
    position: absolute;
  }

  &__badge-key {
    width: 70%;
  }
}

.button__close-modal {
  justify-content: center;
}
</style>
